// Debug logging configuration
// Set to false to disable verbose console logging in production
export const DEBUG_ENABLED = false;

// Conditional logging functions
export const debugLog = (...args) => {
  if (DEBUG_ENABLED) {
    console.log(...args);
  }
};

export const debugWarn = (...args) => {
  if (DEBUG_ENABLED) {
    console.warn(...args);
  }
};

export const debugError = (...args) => {
  // Always log errors
  console.error(...args);
};
